// UI components

import styled from 'styled-components'
import { injectGlobal } from 'styled-components'
import { Link } from 'react-router-dom'

// color definitions

/* eslint-disable */

const fontSizeXL = '1.6rem'
const fontSizeL = '1.3rem'
const fontSizeM = '1.15rem'
const fontSizeS = '1rem'
const fontSizeXS = '.88rem'

const red50 = 'hsl(350, 80%, 50%)'
const red55 = 'hsl(350, 80%, 55%)'
const red60 = 'hsl(350, 80%, 60%)'
const red65 = 'hsl(350, 80%, 65%)'

const blue00 = 'hsl(240, 50%, 00%)'
const blue05 = 'hsl(240, 50%, 05%)'
const blue10 = 'hsl(240, 50%, 10%)'
const blue10t = 'hsla(240, 50%, 10%, 0)'
const blue15 = 'hsl(240, 50%, 15%)'
const blue15t = 'hsla(240, 50%, 15%, 0)'
const blue20 = 'hsl(240, 40%, 20%)'
const blue25 = 'hsl(240, 40%, 25%)'
const blue30 = 'hsl(240, 40%, 30%)'
const blue35 = 'hsl(240, 40%, 35%)'
const blue40 = 'hsl(240, 40%, 40%)'
const blue45 = 'hsl(240, 40%, 45%)'
const blue50 = 'hsl(240, 30%, 50%)'
const blue55 = 'hsl(240, 30%, 55%)'
const blue60 = 'hsl(240, 30%, 60%)'
const blue65 = 'hsl(240, 30%, 65%)'
const blue70 = 'hsl(240, 30%, 70%)'
const blue75 = 'hsl(240, 30%, 75%)'
const blue80 = 'hsl(240, 20%, 80%)'
const blue85 = 'hsl(240, 20%, 85%)'
const blue90 = 'hsl(240, 20%, 90%)'
const blue95 = 'hsl(240, 10%, 95%)'
const blue99 = 'hsl(240, 10%, 99%)'

/* eslint-enable */

// semantic colors

const darkOverlay = blue10
const darkOverlayTransparent = blue10t
const darkOverlayActive = blue00

const background = blue15
const backgroundTransparent = blue15t
const backgroundHighlight = blue20

const button = blue30
const buttonHighlight = blue35
const buttonActive = blue40
const buttonHighlightActive = blue45

const buttonPrimary = red50
const buttonHighlightPrimary = red55
const buttonPrimaryActive = red55
const buttonHighlightPrimaryActive = red60

const shadow = blue05

const textSecondary = blue80
const textPrimary = blue99


// size vars

const pagePadding = '2rem';

// GLOBAL STYLES
injectGlobal`
  @import url('https://fonts.googleapis.com/css?family=Roboto+Mono:200,300,400,500');
  @import url('https://fonts.googleapis.com/css?family=Roboto:400');

  *:before,
  *:after,
  * {
    box-sizing: border-box;
    font-family: roboto, -apple-system, BlinkMacSystemFont, sans-serif;
    font-weight: 400;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    letter-spacing: 0.01rem; /* forgive me lord */
  }

  ::-webkit-scrollbar {
    display: none;
  }

  html {
    margin: 0;
    padding: 0;
    font-size: ${fontSizeS};
    color: ${textSecondary};
    line-height: 1.4;
    background: ${background};
  }
  body {
    margin: 0 auto;
    padding: ${pagePadding};
    max-width: 400px;
  }
  #root {
    /* all parents should have this for the pages that don't live in an appWrapper */
    position: relative;
  }
`

const AppWrapper = styled.div`
  position: relative;
`
const AppBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-image: radial-gradient(circle closest-corner at 150px 200px, ${backgroundHighlight}, ${background});
`

// important for page transitions
const PagesWrapper = styled.div`
  position: relative;
`
const Page = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 0 0 8rem;
`

const Logo = styled.img`
  width: 100%;
  /*
  width: calc(100% + 4rem);
  margin: 0 -${pagePadding} -1rem;
  */
`

const H1 = styled.h1`
  font-size: ${fontSizeXL};
  font-weight: 300;
  font-family: 'roboto mono';
  margin: 1.5rem 0;
  color: ${textPrimary};
`

const H2 = styled.h2`
  font-size: ${fontSizeXS};
  font-family: 'roboto mono';
  margin: 2rem 0 1rem;
  text-transform: uppercase;
  letter-spacing: .03rem;
  font-weight: 400;
  color: ${textPrimary};
`

// BUTTON

const buttonGradient =              `radial-gradient(circle farthest-side at 0px 30px, ${buttonHighlight}, ${button});`
const buttonGradientActive =        `radial-gradient(circle farthest-side at 0px 30px, ${buttonHighlightActive}, ${buttonActive});`
const buttonPrimaryGradient =       `radial-gradient(circle farthest-side at 0px 30px, ${buttonHighlightPrimary}, ${buttonPrimary});`
const buttonPrimaryGradientActive = `radial-gradient(circle farthest-side at 0px 30px, ${buttonHighlightPrimaryActive}, ${buttonPrimaryActive});`

const Button = styled.button`
  width: 100%;
  padding: .8rem;
  font-size: ${fontSizeS};
  font-family: 'roboto mono';
  margin: 0;
  outline: none;
  position: relative;
  border: 1px solid transparent;
  border-radius: 3px;
  cursor: pointer;
  font-weight: 400;
  text-decoration: none;
  display: inline-block;
  text-align: center;
  user-select: none;

  text-shadow: ${p => p.primary ? '0 2px 0px hsl(350,80%,45%)' : '0 2px 0px '+blue25};
  background: ${p => p.primary ? buttonPrimaryGradient : buttonGradient};
  transition: all .15s ease;
  color: ${textPrimary};

  box-shadow: 0 10px 20px -10px ${shadow};
  opacity: 0.95;

  &:hover {
    opacity: 1;
    box-shadow: 0 12px 20px -10px ${shadow};
  }

  &:active {
    background: ${p => p.primary ? buttonPrimaryGradientActive : buttonGradientActive};
    box-shadow: 0 8px 20px -10px ${shadow};
    top: 1px;
  }

  &[disabled],
  &[disabled]:hover {
    cursor: auto;
    opacity: .6;
    background: ${p => p.primary ? red50 : button};
  }
`

const ButtonLink = Button.withComponent(Link)

const ButtonPair = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 1rem;
`

const FixedAction = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: ${pagePadding};
  background: linear-gradient(${backgroundTransparent} 0, ${background} 1.5rem);
`

// INPUT

const Input = styled.input`
  width: 100%;
  padding: 1rem;
  font-size: 1rem;
  font-family: 'roboto mono';
  margin: 0 0 1rem;
  outline: none;
  color: ${textPrimary};
  border: 3px solid ${blue85};
  border-radius: 3px;
  background: ${button};

  &:focus {
    border: 3px solid ${blue95};
    background: ${button};
  }
`

// WELL

const Well = styled.div`
  padding: 1rem;
  margin: 0 0 1.5rem;
  border-radius: 4px;
  color: ${textPrimary};
  background: ${darkOverlay};

  & > *:last-child {
    margin: 0;
  }
`
const WellLabel = H2.extend`
  color: ${red50};
  margin: 0 0 .5rem;
  font-family: 'roboto mono';
`

// CLOSE X

const CloseX = styled.div`
  position: fixed;
  top: .5rem;
  right: .5rem;
  width: 3rem;
  height: 3rem;
  line-height: 3rem;
  font-size: 3rem;
  font-weight: 300;
  text-align: center;
  border-radius: 50%;
  color: ${textPrimary};
  background: ${darkOverlay};
  cursor: pointer;
  transition: all .15s ease;

  &:hover,
  &:active {
    background: ${darkOverlayActive};
  }
`

// SECRET WINDOW

const SecretWindowWrapper = styled.div`
  width: 100%;
  height: 10rem;
  position: relative;
  margin: 0 0 2rem;
  text-align: center;
  user-select: none;
  overflow: hidden;
`

const SecretWindowBackground = styled.div`
  width: 100%;
  height: 10rem;
  position: absolute;
  top: 0px;
  left: 0px;
  padding: 2rem 1rem;

  background: ${darkOverlay};
  color: ${textPrimary};
  overflow: hidden;
`

const SecretWindowBackgroundRegular = styled.div`
  display: block;
  opacity: 0.7;
  font-family: 'roboto mono';
`

const SecretWindowBackgroundEmphasis = styled.div`
  display: block;
  font-size: ${fontSizeM};
  line-height: 2rem;
  font-weight: 400;
  font-family: 'roboto mono';
`

const SecretWindowFlap = styled.div`
  width: 100%;
  height: 10rem;
  position: absolute;
  top: ${p => p.open ? '-95%' : '0%'};
  left: 0px;
  padding: 2rem;

  background: ${red50};
  transition: top .2s ease-in-out;
`

const SecretWindowTitle = styled.div`
  color: ${textPrimary};
  font-weight: 400;
  margin: 1.5rem 0 .3rem;
  font-family: 'roboto mono';
`

const SecretWindowInstructions = styled.div`
  color: ${textPrimary};
  font-size: ${fontSizeXS};
  opacity: .7;
  font-family: 'roboto mono';
`

// LOADER

const LoaderIcon = styled.div`
  width: 2rem;
  height: 2rem;
  margin: 8rem auto;
  background-color: ${red50};
  border-radius: 100%;
  animation: loading 1.4s infinite ease;
`

// RULES

const RuleList = styled.ol`
  padding: 0 0 0 1rem;
  padding: 0;
`
const Rule = styled.li`
  margin: 0 0 1rem;
  list-style: none;
`

// VIDEO

const Video = styled.video`
  background: ${blue00};
  width: 100%;
  height: 200px;
`

// MENU

const MenuWrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  padding: 0.5rem;
  text-align: right;
`
const MenuItem = styled.div`
  cursor: pointer;
  display: inline-block;
  width: ${24 + 12 + 12}px;
  height: ${24 + 12 + 12}px;
  padding: ${12}px;
  text-align: center;
  border-radius: 500px;
  transition: background .15s ease;
  img {
    opacity: .7;
  }
  &:hover {
    background: ${darkOverlay};
    img {
      opacity: 1;
    }
  }
`

// LINK BOX

const linkBoxPadding = '1'

const LinkBoxWrapper = styled.div`
  margin: 0 -${linkBoxPadding}rem 1rem;
  position: relative;

  &::before,
  &::after {
    content: '';
    display: block;
    width: ${linkBoxPadding}rem;
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 10;
  }
  &::before {
    left: 0;
    background: linear-gradient(90deg, ${darkOverlay}, ${darkOverlayTransparent});
  }
  &::after {
    right: 0;
    background: linear-gradient(90deg, ${darkOverlayTransparent}, ${darkOverlay});
  }
`
const LinkBox = styled.a`
  overflow-x: scroll;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  padding: 0 ${linkBoxPadding}rem;
  white-space: nowrap;
  text-decoration: none;
  color: ${textPrimary};
  font-family: 'roboto mono';
  display: block;
`

// LIST OF CELLS

const CellsWrapper = styled.div`
  margin: 0 -${pagePadding};
`
const Cell = styled.div`
  width: 100%;
  padding: 1rem ${pagePadding};
  position: relative;
  outline: none;
  cursor: pointer;
  text-decoration: none;
  display: block;
  margin: 0 0 1px;
  background: ${darkOverlay};
  transition: background .15s ease;
`
const CellWithLink = Cell.withComponent(Link)
const CellLink = CellWithLink.extend`
  &:hover,
  &:active {
    background: ${darkOverlayActive};
  }
`
const CellTitle = styled.div`
  color: ${textPrimary};
  margin: 0 0 .25rem;
  font-family: 'roboto mono';
`
const CellMeta = styled.div`
  color: ${textSecondary};
  font-size: ${fontSizeXS};
  font-weight: 400;
`
const CellChevron = styled.img`
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  right: 1rem;
  width: 24px;
  height: 24px;
`

// ROSTER
const RosterItemWrapper = styled.div`
  display: grid;
  grid-template-columns: 2rem auto;
  margin: 1rem 0;
`
const RosterItemThumb = styled.div`
  border-radius: 100px;
  background:
`
const RosterItemName = styled.div`
  text-decoration: ${p => p.alive ? 'none': 'line-through'};
  opacity: ${p => p.alive ? '1': '0.7'};
  font-family: 'roboto mono';
`
const RosterItemMeta = styled.div`
  font-size: ${fontSizeXS};
  font-weight: 500;
  color: ${red50};
`

export {
  AppWrapper,
  AppBackground,

  PagesWrapper,
  Page,

  Logo,
  H1,
  H2,

  Input,
  Button,
  ButtonLink,
  ButtonPair,
  FixedAction,

  Well,
  WellLabel,

  CloseX,

  SecretWindowWrapper,
  SecretWindowBackground,
  SecretWindowBackgroundRegular,
  SecretWindowBackgroundEmphasis,
  SecretWindowFlap,
  SecretWindowTitle,
  SecretWindowInstructions,

  LoaderIcon,

  RuleList,
  Rule,

  Video,

  MenuWrapper,
  MenuItem,

  LinkBoxWrapper,
  LinkBox,

  CellsWrapper,
  Cell,
  CellLink,
  CellTitle,
  CellMeta,
  CellChevron,

  RosterItemWrapper,
  RosterItemThumb,
  RosterItemName,
  RosterItemMeta,
}



// WEBPACK FOOTER //
// ./src/views/styles.jsx